/** Discount object shared by Meilisearch (`discount`, `discount_app`) and available-products (`price.discount`) */
export interface IProductDiscount {
  id: number | null;
  name: string | null;
  type: `${TYPE_DISCOUNT}`;
  type_display: string;
  /** Badge text, already resolved by the backend */
  label: string;
  /** Badge color in hex, null means use the default front color */
  label_background_color: string | null;
  /** Final discounted price, e.g. "9010.00" */
  price: string;
  start_date: string | null;
  end_date: string | null;
}

export interface IPrice {
  gross: number;
  currency: string;
  discount?: IProductDiscount | null;
  final?: number;
}

export enum TYPE_DISCOUNT {
  EXPIRATION_DISCOUNT = "expiration_discount",
  CUSTOMER_DISCOUNT = "customer_discount",
  PROMOFIT = "promofit",
  FLASH = "flash_sale",
  BLACK_SALE = "black_sale",
  PRIMATON = "primaton",
}

export type typeDiscount = "expiration_discount" | "customer_discount" | "promofit" | "flash_sale";

export interface IGetAvailableProductsResponse {
  success: boolean;
  message: string;
  payload: Array<{
    id: number;
    product: {
      average_weight: number | null;
      id: number;
      is_prepackaged: boolean;
      is_units: boolean;
      is_weightable: boolean;
      name: string;
      sku: string;
    };
    price: IPrice;
    // price_undiscounted: IPrice;
    quantity_available: number;
    max_qty_to_order?: number;
    allow_order_out_of_stock?: boolean;
    is_available: boolean;
    on_sale: boolean;
    step_qty?: number;
    measure_type_display_short?: string | null;
    is_imported?: boolean;
  }>;
  store_changed?: boolean;
  current_store?: ICurrentStore;
}

interface IAddressQuickStart {
  id: number;
  alias: string | null;
  address: string;
  reference: string | null;
  city: string;
  latitude: string;
  longitude: string;
}

export interface QuickStartResponse {
  success: boolean;
  payload: {
    userPaymentMethod: {
      id: number;
      alias: string | null;
      paymentGatewayData: {
        name: string;
        description: string;
      };
      paymentMethod: number;
    };
    shippingAddress?: IAddressQuickStart | null;
    serviceAppointmentType: "at_home" | "on_site";
    lastDeliveryOrder?: IAddressQuickStart | null;
  };
  message: string;
}
